<div class="root-container">
  <app-header />
  <rtr-toasts-container />

  <div class="content">
    <router-outlet />
  </div>
</div>
